import React, { FC, useCallback, useMemo } from "react";
import { generatePath, useNavigate } from "react-router";
import { useDevice, View, Layout } from "@lookiero/aurora";
import { useI18nMessage } from "@lookiero/i18n-react";
import { ProductPreview } from "../../../../../../domain/projections/ProductPreview";
import { useGetTopSellingProducts } from "../../../../behaviors/useGetTopSellingProducts";
import { ProductCarousel } from "../../../../components/productCarousel/ProductCarousel";
import { ProductGallery } from "../../../../components/productGallery/ProductGallery";
import { useStaticInfo } from "../../../../hooks/useStaticInfo";
import { DOMAIN, I18nMessages } from "../../../../i18n/i18n";
import { Routes } from "../../../../routing/routes";
import { List } from "../../../../tracking/tracking";
import { useTrackItemSelected } from "../../../../tracking/useTrackItemSelected";
import { style as topSellingProductsStyle } from "./TopSellingProducts.styles";

const TopSellingProducts: FC = () => {
  const { products } = useGetTopSellingProducts();
  const { screen } = useDevice();
  const {
    session: { user },
    basePath,
    tradename,
  } = useStaticInfo();
  const navigate = useNavigate();

  const style = useMemo(() => topSellingProductsStyle(), []);

  const crossSellingTopSellingTitleText = useI18nMessage({
    domain: DOMAIN,
    id: I18nMessages.CROSS_SELLING_TOP_SELLING_TITLE,
  });

  const trackItemSelected = useTrackItemSelected({
    country: user.country,
    segment: user.segment,
    userId: user.id,
    tradename,
  });
  const handleOnPressProduct = useCallback(
    (product: ProductPreview) => {
      trackItemSelected({
        list: List.BEST_SELLERS,
        productPreview: product,
      });

      navigate(generatePath(`${basePath}/${Routes.PRODUCT_DETAIL}`, { variantId: product.id }), {
        state: { innerNavigation: true },
      });
    },
    [basePath, navigate, trackItemSelected],
  );

  if (!products.length) {
    return null;
  }

  return screen.L ? (
    <Layout style={style.layoutContainer} fullWidth>
      <View style={style.wrapper}>
        <ProductGallery
          products={products}
          title={crossSellingTopSellingTitleText}
          onPressProduct={handleOnPressProduct}
        />
      </View>
    </Layout>
  ) : (
    <ProductCarousel
      products={products}
      title={crossSellingTopSellingTitleText}
      onPressProduct={handleOnPressProduct}
    />
  );
};

export { TopSellingProducts };
